import { ApiResponse, HTTPVerb } from '../Modules/Utils/API/Interfaces/IApi';
import { ApiManager } from '../Modules/Utils/API/ApiManager';

enum APIConstants {
    AppCatalog = '/api/app-catalog/active/',
}

export interface IGetAppCatalogRequestOverride {
    environment?: string;
    version?: number;
}

export interface IGetAppCatalogRequest {
    regulationId: number;
    overrides?: Record<string, IGetAppCatalogRequestOverride>;
}

export interface IGetAppCatalogResponse {
    Catalog: Record<string, any>;
}

export default class AppCatalogApi {
    public static GetAppCatalog = async (
        data: IGetAppCatalogRequest,
    ): Promise<ApiResponse<IGetAppCatalogResponse>> =>
        ApiManager.getAPIInstance().retriedRequest(
            {
                url: APIConstants.AppCatalog,
                method: HTTPVerb.POST,
                data,
            },
            3,
            200,
        );
}
